// import {
//   Box,
//   Grid,
//   Button,
//   TextField,
//   Typography,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Dialog,
//   TablePagination,
//   InputLabel,
//   Select,
//   FormControl,
//   MenuItem,
//   Checkbox,
// } from "@mui/material";
// import { CancelPresentation as CancelPresentationIcon } from "@mui/icons-material";
// import React, { useEffect, useState } from "react";
// import axios from 'axios';
// import {
//   deleteManageBedUpdation,
//   getdrpBedTypeMst,
//   manageBedUpdation,
// } from "../../../../Api/RoomMst/Api";
// import { toast } from "react-toastify";
// import { formatDeleteErrorMessage } from "../../../../GlobalFunction/ErrorMessageHelper";

// const columns = [
//   { id: "PropName", label: "Property", minWidth: 100 },
//   { id: "WingName", label: "Wing", minWidth: 30 },
//   { id: "FloorName", label: "Floor", minWidth: 40 },
//   { id: "RoomTypeName", label: "R_Type", minWidth: 60 },
//   { id: "RoomNo", label: "R_No.", minWidth: 20 },
//   { id: "RoombedName", label: "BedNo", minWidth: 40 },
//   {
//     id: "RoomBedTypeName",
//     label: (props) => (
//       <Box sx={{display:'flex',justifyContent:'center',alignItems:'center'}}>
//          <Checkbox
//           size="small"
//           checked={props.filterNull}
//           onChange={props.onFilterChange}
//         />
//         BType
//       </Box>
//     ),
//     minWidth: 80,
//     filterKey: "filterNullBedType",
//   },
//   {
//     id: "BedRent",
//     label: (props) => (
//       <Box sx={{display:'flex',justifyContent:'center',alignItems:'center'}}>
//          <Checkbox
//           size="small"
//           checked={props.filterNull}
//           onChange={props.onFilterChange}
//         />
//        B_Rent
//       </Box>
//     ),
//     minWidth: 90,
//     filterKey: "filterNullBedRent",
//   },
// ];

// export default function BedUpdation({
//   PropId,
//   getAllRoomBedMstDashBoardDataTable
// }) {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [searchTerms, setSearchTerms] = useState({});
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(15);
//   const [roomBedType, setRoomBedType] = useState([]);
//   const [filters, setFilters] = useState({
//     filterNullRoomType: false,
//     filterNullRoomNo: false,
//     filterNullBedNo: false,
//     filterNullBedType: false,
//     filterNullBedRent: false,
//   });
//    const [globalSearchTerm, setGlobalSearchTerm] = useState('');
//   const [form, setForm] = useState({
//     RoomBedTypeId: "",
//     BedRent: "",
//   });
//   const [rows, setRows] = useState([]);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const [isLoading, setIsLoading] = useState(false);
//   const token = `eyJhbGciOiJIUzI1NiJ9.eyJWYWxpZElzc3VlciI6IlByYXN5c3QiLCJWYWxpZEF1ZGllbmNlIjoiUHJhc3lzdCJ9.gMMGQ74cWLoymeDv0D4c3UQKTEJSCzdkXoxlW4qF5QU`;

//   const fetchBedData = async () => {
//     setIsLoading(true);
//     try {
//       const currentPageForAPI = page + 1;

//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}RoomBedMst/getAllRoomBedMstDashBoard?currentPage=${currentPageForAPI}&limit=${rowsPerPage}`,
//         {
//           "PageNumber": currentPageForAPI,
//           "PageSize": rowsPerPage,
//           "SearchText": "",
//           "PropId": PropId || 77
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (response instanceof Error) {
//         throw response;
//       }

//       const { data: { Status, Data, responseStatusCode, TotalRowCount, PageData } } = response;
//       if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
//         const formattedData = Data.map((bedData) => ({
//           RowNum: bedData.RowNum,
//           PropName: bedData.PropName,
//           WingName: bedData.WingName,
//           FloorName: bedData.FloorName,
//           RoomTypeName: bedData.RoomTypeName,
//           RoomNo: bedData.RoomNo,
//           TotalBeds: bedData.TotalBeds,
//           RoombedName: bedData.RoombedName,
//           RoomBedTypeName: bedData.RoomBedTypeName,
//           BedRent: bedData.BedRent,
//           Remark: bedData.Remark,
//           Status: bedData.Status === null ? "" : bedData.Status == 1 ? "Active" : "Inactive",
//           RoomBedId: bedData.RoomBedId,
//         }));

//         setRows(formattedData);

//         if (PageData) {
//           setTotalRecords(PageData.TotalRecords || 0);
//         } else {
//           setTotalRecords(TotalRowCount || 0);
//         }
//       } else {
//         setRows([]);
//         setTotalRecords(0);
//       }
//     } catch (error) {
//       console.error("Error: Could not get Bed Master Data", error);
//       toast.error("Failed to fetch bed data");
//       setRows([]);
//       setTotalRecords(0);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (isModalOpen && PropId) {
//       fetchBedData();
//     }
//   }, [isModalOpen, page, rowsPerPage, PropId]);

//   useEffect(() => {
//     if (!isModalOpen) {
//       setForm({ RoomBedTypeId: "", BedRent: "" });
//       setSelectedRows([]);
//     }
//   }, [isModalOpen]);

//   const getFlag = () => {
//     if (form.RoomBedTypeId && form.BedRent) {
//       return "";
//     }

//     if (!form.RoomBedTypeId && form.BedRent) {
//       return "RT";
//     }

//     if (form.RoomBedTypeId && !form.BedRent) {
//       return "BT";
//     }
//   };

//   useEffect(() => {
//     (async () => {
//       const response = await getdrpBedTypeMst();

//       if (response instanceof Error) {
//         return toast.error("Error could not fetch bedtypes");
//       }
//       const {
//         data: { Status, Data, responseStatusCode },
//       } = response;
//       if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
//         setRoomBedType(Data);
//       }
//     })();
//   }, []);

//   const handleUpdateBeds = async () => {
//     if (selectedRows.length < 1) {
//       return toast.info("Select atleast one row to update");
//     }
//     if (!form.RoomBedTypeId && !form.BedRent) {
//       return toast.info(
//         "Please fill at least one detail (Bed Type or Bed Rent)"
//       );
//     }
//     const payload = {
//       ManageBedUpdation: selectedRows.map((row) => ({
//         RoomBedId: row.RoomBedId,
//         RoomBedTypeId: form.RoomBedTypeId
//           ? parseInt(form.RoomBedTypeId, 10)
//           : 1,
//         BedRent: form.BedRent ? parseInt(form.BedRent, 10) : 0,
//         Flag: getFlag(),
//       })),
//     };

//     let json = JSON.stringify(payload);
//     json = json.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
//     json = '"' + json + '"';

//     const response = await manageBedUpdation(json);
//     console.log("response", response.data);
//     if (response instanceof Error) {
//       return toast.error("Server error: failed to update");
//     }

//     const {
//       data: { Status, responseStatusCode, Message },
//     } = response;

//     if ((Status === 0, responseStatusCode === 1)) {
//       await fetchBedData();
//       setSelectedRows([]);
//       setForm({ BedRent: "", RoomBedTypeId: "" });
//       toast.success(Message, { autoClose: 1000 });
//     } else {
//       toast.info(Message, { autoClose: 1000 });
//     }
//   };

//   const handleDelete = async () => {
//     if (selectedRows.length < 1) {
//       return toast.info("Select at least 1 row to delete");
//     }

//     const payload = {
//       ManageBedUpdation: selectedRows.map((row) => ({
//         RoomBedId: row.RoomBedId,
//         RoomBedTypeId: 0,
//         BedRent: 0,
//         Flag: "",
//         DBFLAG: "D",
//       })),
//     };

//     let json = JSON.stringify(payload);
//     json = json.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
//     json = '"' + json + '"';

//     const response = await deleteManageBedUpdation(json);

//     if (response instanceof Error) {
//       return toast.error("Error: could not delete all");
//     }

//     const {
//       data: { Status, Message, responseStatusCode, Data },
//     } = response;

//     if (Status === 0 && responseStatusCode === 1) {
//       await fetchBedData();
//       setSelectedRows([]);
//       setIsModalOpen(false);
//       toast.success(Message, {
//         autoClose: 1000,
//       });
//     } else {
//       setSelectedRows([]);
//       setIsModalOpen(false);
//       if (Array.isArray(Data) && Data.length > 0) {
//         const msg = formatDeleteErrorMessage(Data);
//         toast.error(msg, {
//           autoClose: 1000,
//         });
//       } else {
//         toast.error(Message, {
//           autoClose: 1000,
//         });
//       }
//     }
//   };

//   const handleSearchChange = (columnId, value) => {
//     setSearchTerms((prev) => ({ ...prev, [columnId]: value }));
//     setPage(0);
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(+event.target.value);
//     setPage(0);
//   };

//   const handleInputChange = (event) => {
//     const { name, value } = event.target;

//     if (name === "BedRent" && isNaN(value)) {
//       toast.error("Please enter a valid number for Bed Rent", {
//         autoClose: 1000,
//       });
//       return;
//     }
//     setForm((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const handleFilterChange = (filterKey) => (event) => {
//     setFilters((prev) => ({
//       ...prev,
//       [filterKey]: event.target.checked,
//     }));
//   };

// const filteredRows = React.useMemo(() => {
//   let filtered = [...rows]; // Make a copy of all rows

//   filtered = filtered.filter((row) => {
//     return Object.entries(searchTerms).every(([columnId, term]) => {
//       if (!term) return true;
//       const value = row[columnId];
//       if (typeof value === "string") {
//         return value.toLowerCase().includes(term.toLowerCase());
//       } else if (typeof value === "number") {
//         return value.toString().includes(term);
//       }
//       return true;
//     });
//   });


//   if (filters.filterNullRoomType) {
//     filtered = filtered.filter(row => !row.RoomTypeName || row.RoomTypeName.trim() === "");
//   }
//   if (filters.filterNullRoomNo) {
//     filtered = filtered.filter(row => !row.RoomNo || row.RoomNo.trim() === "");
//   }
//   if (filters.filterNullBedNo) {
//     filtered = filtered.filter(row => !row.RoombedName || row.RoombedName.trim() === "");
//   }
//   if (filters.filterNullBedType) {
//     filtered = filtered.filter(row => !row.RoomBedTypeName || row.RoomBedTypeName.trim() === "");
//   }
//   if (filters.filterNullBedRent) {
//     filtered = filtered.filter(row => !row.BedRent || row.BedRent === 0);
//   }

//   return filtered;
// }, [searchTerms, rows, filters]);

//   const isChecked = (RoomBedId) => {
//     return selectedRows.some((row) => row.RoomBedId === RoomBedId);
//   };

//   const checkChangeHandler = (row, isSelectAll) => {
//     if (isSelectAll) {
//       if (filteredRows.length === selectedRows.length) {
//         setSelectedRows([]);
//       } else {
//         setSelectedRows([...filteredRows]);
//       }
//       return;
//     }

//     const isRowSelected = selectedRows.some(
//       (selectedRow) => selectedRow.RoomBedId === row.RoomBedId
//     );

//     if (isRowSelected) {
//       setSelectedRows(
//         selectedRows.filter(
//           (selectedRow) => selectedRow.RoomBedId !== row.RoomBedId
//         )
//       );
//     } else {
//       setSelectedRows([...selectedRows, row]);
//     }
//   };

//   return (
//     <Grid item>
//       <Button
//         variant="contained"
//         color="primary"
//         sx={{
//           background: "#635bff",
//           color: "white",
//           borderRadius: "50px",
//           padding: "8px 20px",
//           boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.3)",
//           transition: "background 0.3s ease",
//         }}
//         size="small"
//         onClick={() => setIsModalOpen(true)}
//       >
//         Bed Updation
//       </Button>

//       <Dialog
//         open={isModalOpen}
//         maxWidth="lg"
//         sx={{
//           "& .MuiDialog-paper": {
//             maxWidth: "70%",
//           },
//         }}
//       >
//         <DialogTitle>
//           <Box
//             display="flex"
//             justifyContent="space-between"
//             alignItems="center"
//           >
//             <Typography variant="title" fontWeight="bold">
//               Bed Data Updation
//             </Typography>

//             <CancelPresentationIcon
//               variant="contained"
//               size="small"
//               colour="primary"
//               onClick={() => setIsModalOpen(false)}
//               sx={{ cursor: 'pointer' }}
//             />
//           </Box>
//         </DialogTitle>
//         <DialogContent sx={{ paddingBlock: "2px", paddingInline: "24px" }}>
//           <Grid item lg={12} md={12} xs={12} sx={{ marginTop: "6px" }}>
//             <Box display="flex" flexDirection="column" gap={2}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} md={3} className="form_field">
//                   <FormControl
//                     variant="filled"
//                     fullWidth
//                     className="custom-select"
//                   >
//                     <InputLabel id="RoomBedTypeId-select-label">
//                       Bed Type
//                     </InputLabel>
//                     <Select
//                       labelId="RoomBedTypeId-select-label"
//                       id="RoomBedTypeId-select"
//                       name="RoomBedTypeId"
//                       value={form.RoomBedTypeId}
//                       onChange={handleInputChange}
//                       className="custom-textfield"
//                     >
//                       {roomBedType.map((bedtype) => {
//                         return (
//                           <MenuItem key={bedtype.Id} value={bedtype.Id}>
//                             {bedtype.Name}
//                           </MenuItem>
//                         );
//                       })}
//                     </Select>
//                   </FormControl>
//                 </Grid>

//                 <Grid item xs={12} md={3}>
//                   <TextField
//                     fullWidth
//                     label="Bed Rent"
//                     name="BedRent"
//                     value={form.BedRent}
//                     onChange={handleInputChange}
//                     variant="filled"
//                     className="custom-textfield"
//                   />
//                 </Grid>

//                 <Grid
//                   item
//                   xs={12}
//                   md={1.3}
//                   sx={{ padding: "0px", border: "black" }}
//                 >
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     onClick={handleUpdateBeds}
//                     sx={{
//                       background: "#635bff",
//                       color: "white",
//                       borderRadius: "50px",
//                       padding: "8px 20px",
//                       margin: "0px 0px 0px 0px",
//                       boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.3)",
//                       transition: "background 0.3s ease",
//                     }}
//                   >
//                     Update
//                   </Button>
//                 </Grid>
//                 <Grid item xs={12} md={1.7}>
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     onClick={handleDelete}
//                     sx={{
//                       background: "#635bff",
//                       color: "white",
//                       borderRadius: "50px",
//                       padding: "8px 20px",
//                       margin: "0px 0px 0px 0px",
//                       boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.3)",
//                       transition: "background 0.3s ease",
//                     }}
//                   >
//                     Delete
//                   </Button>
//                 </Grid>
//               </Grid>
//             </Box>
//           </Grid>

//           <Paper
//             sx={{
//               maxWidth: "100%",
//               overflow: "hidden",
//               margin: "4px 0px 0px 0px",
//               border: "1px solid lightgray",
//             }}
//           >
//             <TableContainer sx={{ maxHeight: 350 }}>
//               <Table stickyHeader aria-label="sticky table">
//                 <TableHead
//                   sx={{
//                     position: "sticky",
//                     top: 0,
//                     zIndex: 1,
//                     backgroundColor: "white",
//                   }}
//                 >
//                   <TableRow
//                     sx={{
//                       "& > th": {
//                         padding: "2px  10px 2px  10px",
//                       },
//                     }}
//                   >
//                     <TableCell
//                       style={{
//                         minWidth: 80,
//                         display: "flex",
//                         flexDirection: "column",
//                         justifyContent: "center",
//                         alignItems: "center",
//                       }}
//                     >
//                       <Typography variant="subtitle1" fontWeight="bold">
//                         All
//                       </Typography>
//                       <Checkbox
//                         sx={{ padding: 0 }}
//                         disableRipple
//                         checked={
//                           filteredRows.length > 0 &&
//                           filteredRows.every((row) => isChecked(row.RoomBedId))
//                         }
//                         onChange={() => checkChangeHandler(null, true)}
//                       />
//                     </TableCell>
//                     {columns.map((column) => (
//                       <TableCell
//                         key={column.id}
//                         style={{ minWidth: column.minWidth }}
//                       >
//                         {column.filterKey ? (
//                           <Box>
//                             <Typography variant="subtitle1" fontWeight="bold">
//                               {typeof column.label === "function"
//                                 ? column.label({
//                                     filterNull: filters[column.filterKey],
//                                     onFilterChange: handleFilterChange(
//                                       column.filterKey
//                                     ),
//                                   })
//                                 : column.label}
//                             </Typography>
//                             <TextField
//                               size="small"
//                               variant="outlined"
//                               placeholder={`Search ${
//                                 typeof column.label === "function"
//                                   ? column.id
//                                   : column.label
//                               }`}
//                               value={searchTerms[column.id] || ""}
//                               onChange={(e) =>
//                                 handleSearchChange(column.id, e.target.value)
//                               }
//                               sx={{
//                                 mt: 1,
//                                 margin: "0px",
//                                 "& .MuiOutlinedInput-input": {
//                                   padding: "2px 2px",
//                                 },
//                               }}
//                             />
//                           </Box>
//                         ) : (
//                           <Box>
//                             <Typography variant="subtitle1" fontWeight="bold">
//                               {column.label}
//                             </Typography>
//                             <TextField
//                               size="small"
//                               variant="outlined"
//                               placeholder={`Search ${column.label}`}
//                               value={searchTerms[column.id] || ""}
//                               onChange={(e) =>
//                                 handleSearchChange(column.id, e.target.value)
//                               }
//                               sx={{
//                                 mt: 1,
//                                 margin: "0px",
//                                 "& .MuiOutlinedInput-input": {
//                                   padding: "2px 2px",
//                                 },
//                               }}
//                             />
//                           </Box>
//                         )}
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {isLoading ? (
//                     <TableRow>
//                       <TableCell colSpan={columns.length + 1} align="center">
//                         Loading...
//                       </TableCell>
//                     </TableRow>
//                   ) : filteredRows.length > 0 ? (
//                     filteredRows.map((row, idx) => {
//                       return (
//                         <TableRow
//                           hover
//                           role="checkbox"
//                           tabIndex={-1}
//                           key={idx}
//                           style={{ cursor: "pointer" }}
//                           sx={{
//                             "& > td": {
//                               padding: "2px  10px 2px  10px",
//                             },
//                           }}
//                         >
//                           <TableCell
//                             style={{
//                               minWidth: 90,
//                               display: "flex",
//                               flexDirection: "column",
//                               justifyContent: "center",
//                               alignItems: "center",
//                             }}
//                           >
//                             <Checkbox
//                               checked={isChecked(row.RoomBedId)}
//                               onChange={() => checkChangeHandler(row)}
//                             />
//                           </TableCell>
//                           {columns.map((column) => {
//                             const value = row[column.id];
//                             return (
//                               <TableCell key={column.id} align={column.align}>
//                                 {value}
//                               </TableCell>
//                             );
//                           })}
//                         </TableRow>
//                       );
//                     })
//                   ) : (
//                     <TableRow>
//                       <TableCell colSpan={columns.length + 1} align="center">
//                         No data available
//                       </TableCell>
//                     </TableRow>
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             <Grid
//               container
//               justifyContent="space-between"
//               alignItems="center"
//               sx={{ padding: "16px" }}
//             >
//               <Grid item>
//                 <Typography variant="body2">
//                   {selectedRows.length > 0
//                     ? selectedRows.length === filteredRows.length
//                       ? `All ${filteredRows.length} rows selected`
//                       : `${selectedRows.length} row${
//                           selectedRows.length > 1 ? "s" : ""
//                         } selected`
//                     : "No rows selected"}
//                 </Typography>
//               </Grid>

//               <Grid item>
//                 <TablePagination
//                   rowsPerPageOptions={[ 15, 50, 100,500,1000,5000]}
//                   component="div"
//                   count={totalRecords}
//                   rowsPerPage={rowsPerPage}
//                   page={page}
//                   onPageChange={handleChangePage}
//                   onRowsPerPageChange={handleChangeRowsPerPage}
//                 />
//               </Grid>
//             </Grid>
//           </Paper>
//         </DialogContent>
//         <DialogActions></DialogActions>
//       </Dialog>
//     </Grid>
//   );
// }


import {
  Box,
  Grid,
  Button,
  TextField,
  Typography,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  TablePagination,
  InputLabel,
  Select,
  FormControl,
  MenuItem,
  Checkbox,
  Pagination,
  Stack,
} from "@mui/material";
import { CancelPresentation as CancelPresentationIcon } from "@mui/icons-material";
import React, { useEffect, useState, useMemo } from "react";
import axios from 'axios';
import {
  deleteManageBedUpdation,
  getdrpBedTypeMst,
  manageBedUpdation,
} from "../../../../Api/RoomMst/Api";
import { toast } from "react-toastify";
import { formatDeleteErrorMessage } from "../../../../GlobalFunction/ErrorMessageHelper";

const columns = [
  { id: "PropName", label: "Property", minWidth: 100 },
  { id: "WingName", label: "Wing", minWidth: 30 },
  { id: "FloorName", label: "Floor", minWidth: 40 },
  { id: "RoomTypeName", label: "R_Type", minWidth: 60 },
  { id: "RoomNo", label: "R_No.", minWidth: 20 },
  { id: "RoombedName", label: "BedNo", minWidth: 40 },
  {
    id: "RoomBedTypeName",
    label: (props) => (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Checkbox
          size="small"
          checked={props.filterNull}
          onChange={props.onFilterChange}
        />
        BType
      </Box>
    ),
    minWidth: 80,
    filterKey: "filterNullBedType",
  },
  {
    id: "BedRent",
    label: (props) => (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Checkbox
          size="small"
          checked={props.filterNull}
          onChange={props.onFilterChange}
        />
        B_Rent
      </Box>
    ),
    minWidth: 90,
    filterKey: "filterNullBedRent",
  },
];

export default function BedUpdation({
  PropId,
  getAllRoomBedMstDashBoardDataTable
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchTerms, setSearchTerms] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [roomBedType, setRoomBedType] = useState([]);
  const [globalSearchTerm, setGlobalSearchTerm] = useState('');
  const [filters, setFilters] = useState({
    filterNullRoomType: false,
    filterNullRoomNo: false,
    filterNullBedNo: false,
    filterNullBedType: false,
    filterNullBedRent: false,
  });
  const [form, setForm] = useState({
    RoomBedTypeId: "",
    BedRent: "",
  });
  const [rows, setRows] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const token = `eyJhbGciOiJIUzI1NiJ9.eyJWYWxpZElzc3VlciI6IlByYXN5c3QiLCJWYWxpZEF1ZGllbmNlIjoiUHJhc3lzdCJ9.gMMGQ74cWLoymeDv0D4c3UQKTEJSCzdkXoxlW4qF5QU`;

  useEffect(() => {
    const timer = setTimeout(() => {
      if (isModalOpen && PropId) {
        fetchBedData(1, rowsPerPage);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [globalSearchTerm, isModalOpen, PropId, rowsPerPage]);

  const fetchBedData = async (pageNumber, pageSize) => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}RoomBedMst/getAllRoomBedMstDashBoard?currentPage=${pageNumber}&limit=${pageSize}`,
        {
          PageNumber: pageNumber,
          PageSize: pageSize,
          SearchText: globalSearchTerm || "",
          PropId: PropId || 77
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response instanceof Error) {
        throw response;
      }

      const { data: { Status, Data, responseStatusCode, TotalRowCount, PageData } } = response;
      if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
        const formattedData = Data.map((bedData) => ({
          RowNum: bedData.RowNum,
          PropName: bedData.PropName || "",
          WingName: bedData.WingName || "",
          FloorName: bedData.FloorName || "",
          RoomTypeName: bedData.RoomTypeName || "",
          RoomNo: bedData.RoomNo || "",
          TotalBeds: bedData.TotalBeds,
          RoombedName: bedData.RoombedName || "",
          RoomBedTypeName: bedData.RoomBedTypeName || "",
          BedRent: bedData.BedRent || 0,
          Remark: bedData.Remark || "",
          Status: bedData.Status === null ? "" : bedData.Status == 1 ? "Active" : "Inactive",
          RoomBedId: bedData.RoomBedId,
        }));

        setRows(formattedData);
        setTotalRecords(PageData?.TotalRecords || TotalRowCount || 0);
      } else {
        setRows([]);
        setTotalRecords(0);
      }
    } catch (error) {
      toast.error("Failed to fetch bed data");
      setRows([]);
      setTotalRecords(0);
    } finally {
      setIsLoading(false);
    }
  };


  // const fetchBedData = async (pageNumber, pageSize) => {
  //   setIsLoading(true);
  //   try {
  //     const currentPageForAPI = page + 1;
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_API_URL}RoomBedMst/getAllRoomBedMstDashBoard?currentPage=${pageNumber}&limit=${pageSize}`,
  //       {
  //         PageNumber: pageNumber,
  //         PageSize: pageSize,
  //         SearchText: "",
  //         PropId: PropId || 77
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     if (response instanceof Error) {
  //       throw response;
  //     }

  //     const { data: { Status, Data, responseStatusCode, TotalRowCount, PageData } } = response;
  //     if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
  //       const formattedData = Data.map((bedData) => ({
  //         RowNum: bedData.RowNum,
  //         PropName: bedData.PropName || "",
  //         WingName: bedData.WingName || "",
  //         FloorName: bedData.FloorName || "",
  //         RoomTypeName: bedData.RoomTypeName || "",
  //         RoomNo: bedData.RoomNo || "",
  //         TotalBeds: bedData.TotalBeds,
  //         RoombedName: bedData.RoombedName || "",
  //         RoomBedTypeName: bedData.RoomBedTypeName || "",
  //         BedRent: bedData.BedRent || 0,
  //         Remark: bedData.Remark || "",
  //         Status: bedData.Status === null ? "" : bedData.Status == 1 ? "Active" : "Inactive",
  //         RoomBedId: bedData.RoomBedId,
  //       }));

  //       setRows(formattedData);
  //       setTotalRecords(PageData?.TotalRecords || TotalRowCount || 0);
  //     } else {
  //       setRows([]);
  //       setTotalRecords(0);
  //     }
  //   } catch (error) {
  //     console.error("Error: Could not get Bed Master Data", error);
  //     toast.error("Failed to fetch bed data");
  //     setRows([]);
  //     setTotalRecords(0);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   if (isModalOpen && PropId) {
  //     fetchBedData(page + 1, rowsPerPage);
  //   }
  // }, [isModalOpen, PropId, page, rowsPerPage]);

  useEffect(() => {
    if (!isModalOpen) {
      setForm({ RoomBedTypeId: "", BedRent: "" });
      setSelectedRows([]);
      setSearchTerms({});
      setPage(0);
    }
  }, [isModalOpen]);

  const getFlag = () => {
    if (form.RoomBedTypeId && form.BedRent) {
      return "";
    }

    if (!form.RoomBedTypeId && form.BedRent) {
      return "RT";
    }

    if (form.RoomBedTypeId && !form.BedRent) {
      return "BT";
    }
  };

  useEffect(() => {
    (async () => {
      const response = await getdrpBedTypeMst();

      if (response instanceof Error) {
        return toast.error("Error could not fetch bedtypes");
      }
      const {
        data: { Status, Data, responseStatusCode },
      } = response;
      if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
        setRoomBedType(Data);
      }
    })();
  }, []);

  const handleUpdateBeds = async () => {
    if (selectedRows.length < 1) {
      return toast.info("Select atleast one row to update");
    }
    if (!form.RoomBedTypeId && !form.BedRent) {
      return toast.info(
        "Please fill at least one detail (Bed Type or Bed Rent)"
      );
    }
    const payload = {
      ManageBedUpdation: selectedRows.map((row) => ({
        RoomBedId: row.RoomBedId,
        RoomBedTypeId: form.RoomBedTypeId
          ? parseInt(form.RoomBedTypeId, 10)
          : 1,
        BedRent: form.BedRent ? parseInt(form.BedRent, 10) : 0,
        Flag: getFlag(),
      })),
    };

    let json = JSON.stringify(payload);
    json = json.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    json = '"' + json + '"';

    const response = await manageBedUpdation(json);
    if (response instanceof Error) {
      return toast.error("Server error: failed to update");
    }

    const {
      data: { Status, responseStatusCode, Message },
    } = response;

    if ((Status === 0, responseStatusCode === 1)) {
      await fetchBedData(page + 1, rowsPerPage);
      setSelectedRows([]);
      setForm({ BedRent: "", RoomBedTypeId: "" });
      toast.success(Message, { autoClose: 1000 });
    } else {
      toast.info(Message, { autoClose: 1000 });
    }
  };

  const handleDelete = async () => {
    if (selectedRows.length < 1) {
      return toast.info("Select at least 1 row to delete");
    }

    const payload = {
      ManageBedUpdation: selectedRows.map((row) => ({
        RoomBedId: row.RoomBedId,
        RoomBedTypeId: 0,
        BedRent: 0,
        Flag: "",
        DBFLAG: "D",
      })),
    };

    let json = JSON.stringify(payload);
    json = json.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    json = '"' + json + '"';

    const response = await deleteManageBedUpdation(json);

    if (response instanceof Error) {
      return toast.error("Error: could not delete all");
    }

    const {
      data: { Status, Message, responseStatusCode, Data },
    } = response;

    if (Status === 0 && responseStatusCode === 1) {
      await fetchBedData(page + 1, rowsPerPage);
      setSelectedRows([]);
      setIsModalOpen(false);
      toast.success(Message, {
        autoClose: 1000,
      });
    } else {
      setSelectedRows([]);
      setIsModalOpen(false);
      if (Array.isArray(Data) && Data.length > 0) {
        const msg = formatDeleteErrorMessage(Data);
        toast.error(msg, {
          autoClose: 1000,
        });
      } else {
        toast.error(Message, {
          autoClose: 1000,
        });
      }
    }
  };

  const handleSearchChange = (columnId, value) => {
    setSearchTerms((prev) => ({ ...prev, [columnId]: value }));
    setPage(0); // Reset to first page when searching
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1); // MUI Pagination is 1-based, but our state is 0-based
    fetchBedData(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    fetchBedData(1, newRowsPerPage);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "BedRent" && isNaN(value)) {
      toast.error("Please enter a valid number for Bed Rent", {
        autoClose: 1000,
      });
      return;
    }
    setForm((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFilterChange = (filterKey) => (event) => {
    setFilters((prev) => ({
      ...prev,
      [filterKey]: event.target.checked,
    }));
    setPage(0);
  };

  const filteredRows = useMemo(() => {
    let filtered = [...rows];

    filtered = filtered.filter((row) => {
      return Object.entries(searchTerms).every(([columnId, term]) => {
        if (!term || term.trim() === "") return true;

        const value = row[columnId];
        if (value === null || value === undefined) return false;

        if (typeof value === "string") {
          return value.toLowerCase().includes(term.toLowerCase().trim());
        } else if (typeof value === "number") {
          return value.toString().includes(term.trim());
        }
        return false;
      });
    });

    // Apply null/empty filters
    if (filters.filterNullRoomType) {
      filtered = filtered.filter(row =>
        !row.RoomTypeName ||
        row.RoomTypeName.toString().trim() === ""
      );
    }
    if (filters.filterNullRoomNo) {
      filtered = filtered.filter(row =>
        !row.RoomNo ||
        row.RoomNo.toString().trim() === ""
      );
    }
    if (filters.filterNullBedNo) {
      filtered = filtered.filter(row =>
        !row.RoombedName ||
        row.RoombedName.toString().trim() === ""
      );
    }
    if (filters.filterNullBedType) {
      filtered = filtered.filter(row =>
        !row.RoomBedTypeName ||
        row.RoomBedTypeName.toString().trim() === ""
      );
    }
    if (filters.filterNullBedRent) {
      filtered = filtered.filter(row =>
        !row.BedRent ||
        row.BedRent === 0 ||
        row.BedRent === null ||
        row.BedRent === undefined
      );
    }

    return filtered;
  }, [rows, searchTerms, filters]);

  const isChecked = (RoomBedId) => {
    return selectedRows.some((row) => row.RoomBedId === RoomBedId);
  };

  const checkChangeHandler = (row, isSelectAll) => {
    if (isSelectAll) {
      if (filteredRows.length === selectedRows.length) {
        setSelectedRows([]);
      } else {
        setSelectedRows([...filteredRows]);
      }
      return;
    }

    const isRowSelected = selectedRows.some(
      (selectedRow) => selectedRow.RoomBedId === row.RoomBedId
    );

    if (isRowSelected) {
      setSelectedRows(
        selectedRows.filter(
          (selectedRow) => selectedRow.RoomBedId !== row.RoomBedId
        )
      );
    } else {
      setSelectedRows([...selectedRows, row]);
    }
  };

  return (
    <Grid item>
      <Button
        variant="contained"
        color="primary"
        sx={{
          background: "#635bff",
          color: "white",
          borderRadius: "50px",
          padding: "6px 15px",
          boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.2)",
          "&:hover": {
            background: "#524ccc"
          }
        }}
        size="small"
        onClick={() => setIsModalOpen(true)}
      >
        Bed Updation
      </Button>

      <Dialog
        open={isModalOpen}
        maxWidth="lg"
        sx={{
          "& .MuiDialog-paper": {
            maxWidth: "70%",
          },
        }}
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="title" fontWeight="bold">
              Bed Data Updation
            </Typography>

            <CancelPresentationIcon
              variant="contained"
              size="small"
              colour="primary"
              onClick={() => setIsModalOpen(false)}
              sx={{ cursor: 'pointer' }}
            />
          </Box>
        </DialogTitle>
        <DialogContent sx={{ paddingBlock: "2px", paddingInline: "24px" }}>
          <Grid item lg={12} md={12} xs={12} sx={{ marginTop: "6px" }}>
            <Box display="flex" flexDirection="column" gap={2}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={3} className="form_field">
                  <FormControl
                    variant="filled"
                    fullWidth
                    className="custom-select"
                  >
                    <InputLabel id="RoomBedTypeId-select-label">
                      Bed Type
                    </InputLabel>
                    <Select
                      labelId="RoomBedTypeId-select-label"
                      id="RoomBedTypeId-select"
                      name="RoomBedTypeId"
                      value={form.RoomBedTypeId}
                      onChange={handleInputChange}
                      className="custom-textfield"
                    >
                      {roomBedType.map((bedtype) => {
                        return (
                          <MenuItem key={bedtype.Id} value={bedtype.Id}>
                            {bedtype.Name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="Bed Rent"
                    name="BedRent"
                    value={form.BedRent}
                    onChange={handleInputChange}
                    variant="filled"
                    className="custom-textfield"
                  />
                </Grid>
                <Grid item xs={12} sm={3} md={3}>
                  <TextField
                    id="globalSearch"
                    name="globalSearch"
                    label="Anything search here..."
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    value={globalSearchTerm}
                    onChange={(e) => setGlobalSearchTerm(e.target.value)}

                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={1.3}
                  sx={{ padding: "0px", border: "black" }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleUpdateBeds}
                    sx={{
                      background: "#635bff",
                      color: "white",
                      borderRadius: "50px",
                      padding: "8px 20px",
                      margin: "0px 0px 0px 0px",
                      boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.3)",
                      transition: "background 0.3s ease",
                    }}
                  >
                    Update
                  </Button>
                </Grid>
                <Grid item xs={12} md={1.7}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDelete}
                    sx={{
                      background: "#635bff",
                      color: "white",
                      borderRadius: "50px",
                      padding: "8px 20px",
                      margin: "0px 0px 0px 0px",
                      boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.3)",
                      transition: "background 0.3s ease",
                    }}
                  >
                    Delete
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>

          <Paper
            sx={{
              maxWidth: "100%",
              overflow: "hidden",
              margin: "4px 0px 0px 0px",
              border: "1px solid lightgray",
            }}
          >
            <TableContainer sx={{ maxHeight: 350 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead
                  sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    backgroundColor: "white",
                  }}
                >
                  <TableRow
                    sx={{
                      "& > th": {
                        padding: "2px  10px 2px  10px",
                      },
                    }}
                  >
                    <TableCell
                      style={{
                        minWidth: 80,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="subtitle1" fontWeight="bold">
                        All
                      </Typography>
                      <Checkbox
                        sx={{ padding: 0 }}
                        disableRipple
                        checked={
                          filteredRows.length > 0 &&
                          filteredRows.every((row) => isChecked(row.RoomBedId))
                        }
                        onChange={() => checkChangeHandler(null, true)}
                      />
                    </TableCell>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.filterKey ? (
                          <Box>
                            <Typography variant="subtitle1" fontWeight="bold">
                              {typeof column.label === "function"
                                ? column.label({
                                  filterNull: filters[column.filterKey],
                                  onFilterChange: handleFilterChange(
                                    column.filterKey
                                  ),
                                })
                                : column.label}
                            </Typography>
                            <TextField
                              size="small"
                              variant="outlined"
                              placeholder={`Search ${typeof column.label === "function"
                                  ? column.id
                                  : column.label
                                }`}
                              value={searchTerms[column.id] || ""}
                              onChange={(e) =>
                                handleSearchChange(column.id, e.target.value)
                              }
                              sx={{
                                mt: 1,
                                margin: "0px",
                                "& .MuiOutlinedInput-input": {
                                  padding: "2px 2px",
                                },
                              }}
                            />
                          </Box>
                        ) : (
                          <Box>
                            <Typography variant="subtitle1" fontWeight="bold">
                              {column.label}
                            </Typography>
                            <TextField
                              size="small"
                              variant="outlined"
                              placeholder={`Search ${column.label}`}
                              value={searchTerms[column.id] || ""}
                              onChange={(e) =>
                                handleSearchChange(column.id, e.target.value)
                              }
                              sx={{
                                mt: 1,
                                margin: "0px",
                                "& .MuiOutlinedInput-input": {
                                  padding: "2px 2px",
                                },
                              }}
                            />
                          </Box>
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isLoading ? (
                    <TableRow>
                      <TableCell colSpan={columns.length + 1} align="center">
                        Loading...
                      </TableCell>
                    </TableRow>
                  ) : filteredRows.length > 0 ? (
                    filteredRows.map((row, idx) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={idx}
                          style={{ cursor: "pointer" }}
                          sx={{
                            "& > td": {
                              padding: "2px  10px 2px  10px",
                            },
                          }}
                        >
                          <TableCell
                            style={{
                              minWidth: 90,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Checkbox
                              checked={isChecked(row.RoomBedId)}
                              onChange={() => checkChangeHandler(row)}
                            />
                          </TableCell>
                          {columns.map((column) => {
                            const value = row[column.id];
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {value}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={columns.length + 1} align="center">
                        No data available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <Grid
              container
              justifyContent="space-between"
              alignItems="center"
              sx={{ padding: "16px" }}
            >
              <Grid item xs={12} md={3}>
                <Typography variant="body2">
                  {selectedRows.length > 0
                    ? selectedRows.length === filteredRows.length
                      ? `All ${filteredRows.length} rows selected`
                      : `${selectedRows.length} row${selectedRows.length > 1 ? "s" : ""
                      } selected`
                    : "No rows selected"}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Showing {filteredRows.length} of {totalRecords} total entries
                </Typography>
              </Grid>

              <Grid item xs={12} md={5} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Stack spacing={2}>
                  <Pagination
                    count={Math.ceil(totalRecords / rowsPerPage)}
                    page={page + 1} // MUI Pagination is 1-based
                    onChange={handleChangePage}
                    color="primary"
                    showFirstButton
                    showLastButton
                    size="small"
                  />
                </Stack>
              </Grid>

              <Grid item xs={12} md={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <FormControl variant="outlined" size="small" sx={{ minWidth: 120 }}>
                  <InputLabel>Rows per page</InputLabel>
                  <Select
                    value={rowsPerPage}
                    onChange={handleChangeRowsPerPage}
                    label="Rows per page"
                  >
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                    <MenuItem value={500}>500</MenuItem>
                    <MenuItem value={1000}>1000</MenuItem>
                    <MenuItem value={5000}>5000</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Paper>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </Grid>
  );
}